module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner_affiliate-909e5676e2cb78a0f3d5df4015f1ec45.png";